var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7998 20H4.7998M22.7998 28H12.7998M4.79981 16.4L4.7998 31.6C4.7998 33.8402 4.7998 34.9603 5.23578 35.816C5.61927 36.5686 6.23119 37.1805 6.98384 37.564C7.83949 38 8.95959 38 11.1998 38L38.3998 38C40.64 38 41.7601 38 42.6158 37.564C43.3684 37.1805 43.9803 36.5686 44.3638 35.816C44.7998 34.9603 44.7998 33.8402 44.7998 31.6V16.4C44.7998 14.1598 44.7998 13.0397 44.3638 12.184C43.9803 11.4314 43.3684 10.8195 42.6158 10.436C41.7601 10 40.64 10 38.3998 10L11.1998 10C8.9596 10 7.83949 10 6.98384 10.436C6.23119 10.8195 5.61927 11.4314 5.23578 12.184C4.79981 13.0397 4.79981 14.1598 4.79981 16.4Z",
    stroke: "#83F279",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.80c8ced252a3579c2759e3984e857c47.svg";
export { ForwardRef as ReactComponent };